export default __webpack_public_path__ + "img/bbb.e2d1d4d9.png";